@if (direction === 'back') {
  <kb-icon [icon]="icon ?? iconBack"></kb-icon>
}
<span>
  <ng-content></ng-content>
</span>
@if (direction === 'forward') {
  <kb-icon [icon]="icon ?? iconForward"></kb-icon>
}
